var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('h3',[_vm._v("Daily Rate Chart")]),_c('h3',[_vm._v(" "+_vm._s(_vm._f("formatDateonly")(Date()))+" ")]),_c('bar-chart',{attrs:{"data1":_vm.mydata}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }